import { Router, RoutesRecognized } from '@angular/router';

import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { Menu } from './menu.model';
import { RenderableMenu } from './renderable-menu.model';

export class MenuService {
  private _menu: RenderableMenu[];

  private _url: BehaviorSubject<string>;

  /**
   * Gets the full menu tree.
   *
   * Can be observed for lazy loaded changes.
   */
  public get menu(): RenderableMenu[] {
    return this._menu;
  }

  constructor(
    readonly config: Menu[],
    readonly router: Router
  ) {
    // Initialize with current router URL to handle page reloads and direct url navigation correctly
    this._url = new BehaviorSubject(router.url || '/');

    this._menu = this.toRenderables(config, null);
    router.events
      .pipe(
        filter((event) => event instanceof RoutesRecognized),
        map((event: RoutesRecognized) => event.urlAfterRedirects)
      )
      .subscribe(this._url);
  }

  get url(): Observable<string> {
    return this._url;
  }

  public toRenderables(menus: Menu[], parentUrl: string | null): RenderableMenu[] {
    return menus.map((menu) => {
      const renderable = new RenderableMenu(menu, parentUrl, this.url);
      if (menu.children) {
        renderable.loadChildren(this.toRenderables(menu.children, renderable.url));
      }
      return renderable;
    });
  }
}
